import { BrandThemeTokens } from './types';

export const chadebebeTheme: BrandThemeTokens = {
  palette: {
    primaryMain: '#f08f7d',
    secondaryMain: '#7aa993',
    backgroundDefault: '#fffaf6',
    surface: '#ffffff',
    surfaceAlt: '#fff4eb',
    textPrimary: '#2f3245',
    textSecondary: '#5f6678',
    heroGradientStart: '#fff7f1',
    heroGradientEnd: '#ffe6d7',
    heroGlow: 'rgba(240, 143, 125, 0.28)',
    borderSoft: 'rgba(72, 79, 110, 0.14)',
  },
  typography: {
    fontFamily: '"Nunito", "Segoe UI", "Helvetica Neue", sans-serif',
    headingFontFamily: '"Nunito", "Segoe UI", "Helvetica Neue", sans-serif',
    bodyFontFamily: '"Nunito", "Segoe UI", "Helvetica Neue", sans-serif',
    headingWeight: 800,
    bodyWeight: 500,
    buttonWeight: 800,
  },
};
